import useDeviceScreen from "../../../hooks/useDeviceScreen";
import Header, { HeaderLeft } from "../../../layout/Header/Header";
import Navigation from "../../../layout/Navigation/Navigation";
import { componentPagesMenu } from "../../../menu";
import CommonHeaderRight from "./CommonHeaderRight";

const DefaultHeader = () => {
  const { width } = useDeviceScreen();
  return (
    <Header>
      <HeaderLeft>
        <Navigation
          // menu={{ ...pageLayoutTypesPagesMenu, ...componentPagesMenu }}
          menu={{...componentPagesMenu }}
          id="header-top-menu"
          horizontal={
            !!width &&
            width >= Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)
          }
        />
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default DefaultHeader;
